export const fireRefersionTracking = (planOption, stripeCustomer, subscriptionId) => {
  return // currented turned off
  const script = document.createElement('script')
  document.body.appendChild(script)
  script.onload = () => {
    _refersion(function()
     { _rfsn._setSource("STRIPE"); _rfsn._addCart(stripeCustomer.id); }
     );

    _refersion(function(){
      _rfsn._addTrans({
        'order_id': `order-${stripeCustomer.id}-${(new Date()).getTime()}`,
        'event_id': `order-${stripeCustomer.id}-${(new Date()).getTime()}`,
        'subscription_id': subscriptionId,
        'is_subscription': true,
        'currency_code': planOption.currency.toUpperCase(),
      });
      _rfsn._addCustomer({
        'email': stripeCustomer.email,
      });
      _rfsn._addItem({
        'sku': planOption.id,
        'quantity': 1,
        'price': planOption.amount / 100,
      });
      _rfsn._sendConversion();
    });
  }
  script.src = 'https://curl.refersion.com/tracker/v3/pub_0f8eab46081ed64d4c31.js'
}